// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__39j0l","noInteraction":"EventWrapper_noInteraction__1ml74","pointerPassthrough":"EventWrapper_pointerPassthrough__3Ct9c"};